import React from "react"

const TickModalIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 35 35">
    <g fill="none" fillRule="evenodd">
      <circle fill="#7DBE37" cx="17.5" cy="17.5" r="17.5" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M15.034 22.85l-5.33-3.88L8 21.036 15.48 27 25 11.39 22.79 10z" />
    </g>
  </svg>
)

export default TickModalIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/TickModalIcon.jsx